const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/services.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/services')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});